import { Stack } from 'expo-router';
import React from 'react';

function SpendBenefitsLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default SpendBenefitsLayout;
